import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import FeaturedArticles from './components/FeaturedArticles';
import CategorySection from './components/CategorySection';
import StatsSection from './components/StatsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '开运体育官方平台——赢在每一场',
            description: '开运体育是专业的体育竞技与赛事服务平台，涵盖体育资讯、赛事预测、运动健康等全方位内容。',
            url: 'https://www.kaiyunsports.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: '开运体育',
              url: 'https://www.kaiyunsports.com',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.kaiyunsports.com/' },
              ],
            },
          }),
        }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <Hero />
          <FeaturedArticles />
          <CategorySection />
          <StatsSection />
          <FAQSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}